<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>Banner 管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-permission="Auth.bannerManage"
          @click="handleEdit"
          >新增 Banner</el-button
        >
      </div>
      <el-table :data="list" stripe style="width: 100%">
        <el-table-column align="left" label="轮播图">
          <template slot-scope="scope">
            <auth-img
              tag="el-image"
              style="width: 160px; height: 90px"
              :src="scope.row.cover"
              fit="cover"
            >
              <div slot="error" class="image-slot">暂无图片</div>
            </auth-img>
          </template>
        </el-table-column>
        <el-table-column align="center" label="关联对象" prop="category">
          <template slot-scope="scope"
            >{{ BannerCategoryMap[scope.row.category]
            }}<span v-if="scope.row.category > 1"
              >：{{
                scope.row.category == 2
                  ? scope.row.commodity.part_number
                  : scope.row.wiki.title
              }}</span
            ></template
          >
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <status-tag
              :type="scope.row.status == 2 ? 'success' : 'gray'"
              :name="scope.row.status == 2 ? '启用' : '禁用'"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="120px">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.bannerManage"
              v-if="scope.row.status == 1"
              title="确认删除该Banner吗？"
              @confirm="handleDelete(scope.$index, scope.row.id)"
            >
              <el-button
                slot="reference"
                type="danger"
                plain
                size="mini"
                class="mr-10"
                >删除</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-permission="Auth.bannerManage"
              :title="`确认${scope.row.status == 2 ? '禁用' : '启用'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button
                slot="reference"
                :type="scope.row.status == 2 ? 'danger' : 'primary'"
                plain
                size="mini"
                >{{ scope.row.status == 2 ? '禁用' : '启用' }}</el-button
              >
            </el-popconfirm>
            <el-button
              v-permission="Auth.bannerManage"
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-if="scope.row.status == 2"
              @click="handleTop(scope.row.id)"
              >置顶</el-button
            >
            <el-button
              v-permission="Auth.bannerManage"
              class="ml-10"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-if="scope.row.category == 1"
              @click="handleShow(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ModelFormer
      :model="model"
      :show.sync="modelFormerVisible"
      @created="getData"
      @updated="getData"
    ></ModelFormer>
    <ModelDetail :model="showModel" :show.sync="showModelDialog"></ModelDetail>
  </div>
</template>

<script>
import {
  bannerList,
  updateBannerStatus,
  topBanner,
  deleteBanner,
} from '@/service/getData'
import ModelFormer from './former'
import { BannerCategoryMap } from '@/config/global'
import ModelDetail from './detail.vue'

export default {
  components: {
    ModelFormer,
    ModelDetail,
  },
  data() {
    return {
      BannerCategoryMap,
      showModel: {},
      showModelDialog: false,
      model: {
        cover: '',
        category: 1,
        commodity_id: null,
        wiki_id: null,
        content: '',
      },
      modelFormerVisible: false,
      editIndex: 0,
      list: [],
    }
  },
  watch: {
    'filter.page': function () {
      this.getData()
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await bannerList()
      this.list = res.data.list
    },
    handleEdit(index, item) {
      this.modelFormerVisible = true
      this.$nextTick(() => {
        if (item) {
          this.editIndex = index
          this.model = this.clone(item)
        } else {
          this.model = {
            cover: '',
            category: 1,
            commodity_id: null,
            wiki_id: null,
            content: '',
          }
        }
      })
    },
    async handleTop(id) {
      let res = await topBanner(id)
      if (res.code == 0) {
        this.$message.success('操作成功')
        this.getData()
      }
    },
    async handleSwitchStatus(index, id) {
      let res = await updateBannerStatus(id)
      if (res.code == 0) {
        this.getData()
      }
    },
    async handleDelete(index, id) {
      let res = await deleteBanner(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
    handleShow(item) {
      this.showModel = item
      this.showModelDialog = true
    },
  },
}
</script>